<template>
  <div class="abtesting-config">
    <h3>Scénarios A/B</h3>
    <div
      class="ab-row"
      v-for="(variant, index) in localVariants"
      :key="index"
    >
      <label>Nom du test</label>
      <input v-model="variant.name" placeholder="Nom du test (ex: Message d’accueil A)" />

      <label>Message ou réponse</label>
      <textarea
        v-model="variant.content"
        placeholder="Texte exact de la réponse à tester"
        rows="3"
      ></textarea>

      <button @click="removeVariant(index)">Supprimer</button>
    </div>

    <button class="add-button" @click="addVariant">+ Ajouter une variante</button>
  </div>
</template>

<script>
export default {
  name: 'ABTestingConfig',
  props: {
    modelValue: {
      type: Object,
      required: true
    }
  },
  emits: ['update:modelValue'],
  data() {
    return {
      localVariants: []
    }
  },
  watch: {
    modelValue: {
      immediate: true,
      handler(newVal) {
        this.localVariants = Array.isArray(newVal.variants)
          ? JSON.parse(JSON.stringify(newVal.variants))
          : []
      }
    }
  },
  methods: {
    emitUpdate() {
      this.$emit('update:modelValue', { ...this.modelValue, variants: this.localVariants })
    },
    addVariant() {
      this.localVariants.push({ name: '', content: '' })
      this.emitUpdate()
    },
    removeVariant(index) {
      this.localVariants.splice(index, 1)
      this.emitUpdate()
    }
  }
}
</script>

<style scoped>
.abtesting-config {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.ab-row {
  background: #f3f4f6;
  padding: 1rem;
  border-radius: 8px;
}

input,
textarea {
  width: 100%;
  margin-top: 0.5rem;
  margin-bottom: 1rem;
  padding: 8px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
}

button {
  background-color: #ef4444;
  color: white;
  padding: 8px 14px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
}

.add-button {
  background-color: #10b981;
  margin-top: 1rem;
}
</style>
